import { mapGetters } from "vuex";
export default {
  props: {
    brandList: {
      type: Array,
    },
    title: {
      type: String,
    },
    columns: {
      type: Array,
    },
    api: {
      type: Array,
    },
    selecttype: {
      type: String,
      default: "radio",
    },
    modelback: {
      type: Function,
    },
    modeltype: {
      type: String,
    },
    modelparam: {
      type: Object,
      default: () => {
        return {};
      },
    },
    computed: {
      ...mapGetters(["styleTheme"]),
    },
    selectData: {
      type: [String, Number, Array],
      default: () => {
        return [];
      },
    },
    selectDataKey: {
      type: String,
    },
    selectDataName: {
      type: String,
    },
    beforeHandleClose: {
      type: Function,
    },
    showSearchBox: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["styleTheme"]),
  },
  data() {
    let obj = {};
    console.log("弹窗谈起222222");
    console.log(this.selectDataKey, this.selectDataName);
    console.log(this.selectData);
    this.selectData.map((item) => {
      let tempObj = {};
      this.columns.forEach((column) => {
        tempObj[column.mapKey || column.prop] =
          item[column.mapKey || column.prop];
      });
      console.log(tempObj);
      obj[String(item[this.selectDataKey])] = tempObj;
    });
    console.log(this.selectData, obj, this.columns);
    return {
      tableData: [],
      dialogVisible: true,
      tableLoading: true,
      selectList: this.selectData || [],
      selectMap: obj,
      radio: "",
      pageSize: 10,
      totalItem: 0,
      pagination: true,
      currentPage: 1,
      totalPage: 0,
      checkType: "",
      formSearch: {
        trunkNameKeyWord: "",
      },
      brandId: "",
      list: Object.values(obj),
      trunkType55: "",
      ad: true,
    };
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.currentPage - 1) * this.pageSize;
    },
    init(listt, lijko, trunkTypeMaomao) {
      this.trunkType55 = trunkTypeMaomao;
      console.log("进入代理商");
      if (lijko != null && lijko.length > 0) {
        console.log(lijko);
        this.brandId = lijko[0].brandId;
      } else {
        this.brandId = "";
      }

      if (listt) {
        this.list = [];
        listt.forEach((item) => {
          this.list.push({ brandId: item.brandId, brandName: item.brandName });
        });
        let obj = {};
        console.log(this.selectDataKey, this.selectDataName);
        console.log(this.selectData);
        listt.map((item) => {
          let tempObj = {};
          this.columns.forEach((column) => {
            tempObj[column.mapKey || column.prop] =
              item[column.mapKey || column.prop];
          });
          console.log(tempObj);
          obj[String(item[this.selectDataKey])] = tempObj;
        });
        this.selectMap = obj;
      }

      this.radio = "";
      this.dialogVisible = true;
      this.tableLoading = true;
      const params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$nextTick(() => {
        this.checkType = this.selecttype;
      });
      if (trunkTypeMaomao == 16) {
        params.trunkType = 64;
        params.brandId = this.brandId;
        this.formSearch.brandId = this.brandId;
      }
      this.$api.client
        .regionagentPage({
          ...this.modelparam,
          ...params,
          ...this.formSearch,
        })
        .then((res) => {
          console.log("表4534格数据");
          console.log(res);
          // this.$api[this.api[0]]
          //   [this.api[1]]({
          //     ...this.modelparam,
          //     ...params,
          //     ...this.formSearch,
          //   })
          //   .then((res) => {

          this.tableData = res.map((item) => {
            item.check = false;
            return { ...item };
          });

          this.pagination = false;

          console.log("表格数据-----------");
          console.log(this.columns);
          console.log("表格数据-----------");
          console.log(this.tableData);
          const keys = Object.keys(this.selectMap);
          console.log("表格数据-----------22");
          console.log(keys);
          if (keys.length > 0) {
            if (trunkTypeMaomao == 16) {
              this.tableData.forEach((row, index) => {
                if (row.trunkId == listt[0].regionAgentId) {
                  console.log("找到象牙塔" + JSON.stringify(row));
                  this.rowClick(row);
                }
              });
            } else {
              this.tableData.forEach((item) => {
                if (keys.indexOf(String(item[this.columns[0].prop])) > -1) {
                  console.log(item);
                  this.$nextTick(() => {
                    this.$refs.table.toggleRowSelection(item, true);
                  });
                }
              });
            }
          }
          if (trunkTypeMaomao == 16) {
            console.log("111表格数据3424234");
            console.log(listt[0].regionAgentId);
          }
          this.$nextTick(() => {});
          console.log("111表格数据");
          console.log(this.tableData);
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 页面数据数量变换
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.init();
    },
    // 当前页码变换
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init();
    },
    // 查询
    search() {
      this.init();
    },
    reset() {
      this.currentPage = 1;
      this.formSearch.trunkNameKeyWord = "";
      this.init();
    },
    cancel() {
      this.formSearch.trunkNameKeyWord = "";
      this.modelback("cancel");
      this.dialogVisible = false;
    },
    handleSure() {
      if (this.beforeHandleClose) {
        this.beforeHandleClose(this.handleCloseNotRequired);
      } else {
        this.handleClose();
      }
    },
    // 传递选中的数据
    handleClose(action) {
      if (action === "cancel") {
        return;
      }
      this.selectList = Object.values(this.selectMap);
      if (!this.selectList.length) {
        this.$message({
          message: `请${this.title}`,
          type: "error",
          duration: 3 * 1000,
        });
        return;
      }

      this.modelback(this.modeltype, this.selectList);
      this.dialogVisible = false;
    },
    // 传递选中的数据
    handleCloseNotRequired() {
      this.selectList = Object.values(this.selectMap);

      this.modelback(this.modeltype, this.selectList);
      this.dialogVisible = false;
    },
    selectCheckbox(selection, row) {
      this.rowClick(row);
    },
    // 选中列表点击删除
    handleTagClose(item) {
      const key = String(item[this.selectDataKey]);
      const row = this.tableData.find((data) => {
        return key === String(data[this.columns[0].prop]);
      });
      this.$delete(this.selectMap, key);
      let index = this.list.findIndex((item) => {
        return item[this.columns[0].mapKey || this.columns[0].prop] == key;
      });
      this.list.splice(index, 1);
      this.$refs.table.toggleRowSelection(row, false);
    },
    // 点击行
    rowClick(row, column, event) {
      console.log("rowClick");
      if (this.selecttype === "radio") {
        // TODO:判断条件有问题待处理
        this.tableData.forEach((item, index) => {
          let flag = true;
          this.columns.forEach((column) => {
            if (item[column.prop] !== row[column.prop]) {
              flag = false;
            }
          });
          if (flag) {
            item.check = true;
            this.radio = item[this.columns[0].prop];
            let tempObj = {};
            this.selectMap = {};
            const key = String(row[this.columns[0].prop]);
            this.columns.forEach((column) => {
              tempObj[column.mapKey || column.prop] =
                row[column.prop || column.prop];
            });
            this.$set(this.selectMap, key, tempObj);
          } else {
            item.check = false;
          }
        });
      } else if (this.selecttype === "checkbox") {
        console.log(this.list);
        const keys = Object.keys(this.selectMap);
        const key = String(row[this.columns[0].prop]);
        const checkStatus = keys.includes(key);
        if (!checkStatus) {
          let tempObj = {};
          this.columns.forEach((column) => {
            tempObj[column.mapKey || column.prop] =
              row[column.prop || column.prop];
          });
          this.$set(this.selectMap, key, tempObj);
          this.list.push(tempObj);
        } else {
          this.$delete(this.selectMap, key);
          let index = this.list.findIndex((item) => {
            return (
              String(item[this.columns[0].mapKey || this.columns[0].prop]) ==
              key
            );
          });
          this.list.splice(index, 1);
        }

        console.log(this.selectMap);
        this.$refs.table.toggleRowSelection(row, !checkStatus);
      }
    },
    handleSelectAll(selection) {
      this.tableData.forEach((row) => {
        this.rowClick(row);
      });
    },
    cellInput(row, columnKey) {
      console.log(row);
      console.log(columnKey);
      const key = String(row[this.columns[0].prop]);
      this.selectMap[key] && (this.selectMap[key][columnKey] = row[columnKey]);
      console.log(this.selectMap);
    },
  },
};
